import React, { Component } from "react";
import ThemeSection from "./ThemeSection";
import { withStyles } from "@material-ui/core/styles";
import { colorStyles } from "../themeEditor_style";
import ColorPalette from "./Color/ColorPalette";
import SelectedColors from "./Color/SelectedColors";
import DefaultBackgroundColor from "./Color/DefaultBackgroundColor";
import ThemeOptions from "./ThemeOptions";
import styled from "styled-components";
import ThemeEditorContainer from "js/react/views/ThemeEditor/containers/themeEditor_container";
import { PaletteColorType } from "common/constants";
import { Icon } from "@material-ui/core";
import { Gap, Gap10, Gap20 } from "js/react/components/Gap";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import ColorChit from "./Color/ColorChit";
import { ColorChitCollection } from "js/react/views/ThemeEditor/components/Color/ColorChitCollection";
import { _, tinycolor } from "js/vendor";
import { blendColors } from "js/core/utilities/utilities";
import { BackgroundImages } from "js/react/views/ThemeEditor/components/BackgroundImages";

const backgroundStyle = [
    {
        value: "none",
        label: "None",
        src: "/images/theme_editor/Shape-None.svg"
    },
    {
        value: "vignette",
        label: "Vignette",
        src: "/images/theme_editor/Background-Vignette.svg"
    },
    {
        value: "gradient",
        label: "Gradient",
        src: "/images/theme_editor/Background-Gradient.svg"
    },
    {
        value: "reverseGradient",
        label: "Reverse",
        src: "/images/theme_editor/Background-Reverse.svg"
    },
    {
        value: "border",
        label: "Border",
        src: "/images/theme_editor/Background-Border.svg"
    }
];

class ThemeColors extends Component {
    replacePalette = palette => {
        if (!palette.colors.hasOwnProperty("chart1")) {
            let index = 2;
            palette.colors["chart1"] = palette.colors.theme;

            for (let colorName of Object.keys(palette.colors)) {
                if (colorName.startsWith("accent")) {
                    palette.colors["chart" + index] = palette.colors[colorName];
                    index++;
                }
            }
        }
        if (!palette.colors.hasOwnProperty(PaletteColorType.BACKGROUND_ACCENT)) {
            let blendColor = tinycolor(palette.colors[PaletteColorType.THEME]).setAlpha(0.1);
            palette.colors[PaletteColorType.BACKGROUND_ACCENT] = blendColors(blendColor, tinycolor("white")).toRgbString();
        }

        if (!palette.colors.hasOwnProperty(PaletteColorType.POSITIVE)) {
            palette.colors[PaletteColorType.POSITIVE] = "#54C351";
        }
        if (!palette.colors.hasOwnProperty(PaletteColorType.NEGATIVE)) {
            palette.colors[PaletteColorType.NEGATIVE] = "#E04C2B";
        }

        this.props.update(palette);
    };

    updateColor = (name, color) => {
        let { colors } = this.props.theme;
        colors = { ...colors, [name]: color };
        this.props.update({ colors, palette_name: "custom" });
    };

    handleUpdateColors = colors => {
        let paletteColors = Object.assign({}, this.props.theme.colors);

        // delete all accent colors
        for (let name of Object.keys(paletteColors)) {
            if (name.startsWith("accent")) {
                delete paletteColors[name];
            }
        }

        // add theme and accent colors
        for (let i = 0; i < colors.length; i++) {
            if (i == 0) {
                paletteColors.theme = colors[0];
            } else {
                paletteColors["accent" + i] = colors[i];
            }
        }

        this.props.update({
            colors: paletteColors,
            palette_name: "custom"
        });
    }

    handleUpdateChartColors = colors => {
        let paletteColors = Object.assign({}, this.props.theme.colors);

        // delete all chart colors
        for (let name of Object.keys(paletteColors)) {
            if (name.startsWith("chart")) {
                delete paletteColors[name];
            }
        }

        for (let i = 0; i < colors.length; i++) {
            paletteColors["chart" + (i + 1)] = colors[i];
        }

        this.props.update({
            colors: paletteColors,
            palette_name: "custom"
        });
    };

    updateBackgroundStyle = value => {
        const defaultBackgroundColor = this.props.theme
            .defaultBackgroundColor;
        switch (value.styleBackground) {
            case "gradient":
            case "reverseGradient":
                if (
                    !defaultBackgroundColor ||
                    defaultBackgroundColor ===
                    PaletteColorType.BACKGROUND_LIGHT
                ) {
                    this.props.update({
                        ...value,
                        defaultBackgroundColor: "theme"
                    });
                } else {
                    this.props.update(value);
                }
                break;
            default:
                this.props.update({
                    ...value,
                    defaultBackgroundColor:
                        this.props.theme.lastDefaultBackgroundColor ||
                        PaletteColorType.BACKGROUND_LIGHT
                });
        }
    };

    addBackground = () => {
        let { backgrounds = [] } = this.props.theme;

        backgrounds.push({
            type: "color",
            color: "#FFAA00"
        });

        this.props.update({ backgrounds });
    }

    deleteBackground = background => {
        let { backgrounds = [] } = this.props.theme;
        backgrounds.remove(background);
        this.props.update({ backgrounds });
    }

    render() {
        let {
            classes,
            theme,
        } = this.props;

        let paletteColors = [];
        let chartColors = [];

        paletteColors.push(theme.colors.theme);
        for (let colorName of Object.keys(theme.colors)) {
            if (colorName.startsWith("accent")) {
                paletteColors.push(theme.colors[colorName]);
            }
            if (colorName.startsWith("chart")) {
                chartColors.push(theme.colors[colorName]);
            }
        }

        return (
            <ThemeSection title="Colors">
                <div className={classes.paletteParent}>
                    <h4>Palette</h4>
                    <ColorPalette update={this.replacePalette} theme={theme} />
                </div>
                <hr />

                <div style={{ clear: "both" }} />
                <h4>Colors</h4>
                <ColorChitCollection paletteName={theme.palette_name} colors={paletteColors} {...this.props} onUpdate={this.handleUpdateColors} />

                <div style={{ clear: "both", height: 1 }} />
                <div className={classes.inlineRow}>
                    <h4>Text Colors</h4>
                    <ColorChit
                        color={theme.colors.primary_dark}
                        name="primary_dark"
                        onChange={color => this.updateColor("primary_dark", color)}
                    />
                    <ColorChit
                        color={theme.colors.primary_light}
                        name="primary_light"
                        previewBackground="black"
                        onChange={color => this.updateColor("primary_light", color)}
                    />
                    <div className={classes.label}>Primary</div>
                </div>
                <div className={classes.inlineRow}>
                    <h4></h4>
                    <ColorChit
                        color={theme.colors.secondary_dark}
                        name="secondary_dark"
                        onChange={color => this.updateColor("secondary_dark", color)}
                    />
                    <ColorChit
                        color={theme.colors.secondary_light}
                        name="secondary_light"
                        previewBackground="black"
                        onChange={color => this.updateColor("secondary_light", color)}
                    />

                    <div className={classes.label}>Secondary</div>
                </div>

                <div>
                    <h4>Special Colors</h4>
                    <div className={classes.inlineRow}>
                        <ColorChit
                            color={theme.colors.positive}
                            name="positive"
                            onChange={color => this.updateColor("positive", color)}
                        />
                        <div className={classes.label}>Positive</div>
                    </div>
                    <div className={classes.inlineRow}>
                        <ColorChit
                            color={theme.colors.negative}
                            name="negative"
                            onChange={color => this.updateColor("negative", color)}
                        />
                        <div className={classes.label}>Negative</div>
                    </div>
                </div>

                <div>
                    <h4>Chart Colors</h4>
                    <div className={classes.inlineRow}>
                        <ColorChitCollection paletteName={theme.palette_name} colors={chartColors} {...this.props}
                            onUpdate={this.handleUpdateChartColors} />
                    </div>
                </div>

                <div>
                    <h4>Background Colors</h4>
                    <div className={classes.inlineRow}>
                        <ColorChit
                            color={theme.colors.background_light}
                            name="background_light"
                            onChange={color => this.updateColor("background_light", color)}
                        />
                        <div className={classes.label}>Light</div>
                    </div>
                    <div className={classes.inlineRow}>
                        <ColorChit
                            color={theme.colors.background_dark}
                            name="background_dark"
                            onChange={color => this.updateColor("background_dark", color)}
                        />
                        <div className={classes.label}>Dark</div>
                    </div>
                    <div className={classes.inlineRow}>
                        <ColorChit
                            color={theme.colors.background_accent}
                            name="background_accent"
                            onChange={color => this.updateColor("background_accent", color)}
                        />
                        <div className={classes.label}>Accent</div>
                    </div>

                    <div className={classes.inlineRow}>
                        <DefaultBackgroundColor
                            theme={theme}
                            classes={classes}
                            update={this.props.update}
                        />

                        <div className={classes.label}>Default</div>
                    </div>
                </div>

                <div>
                    <ThemeOptions
                        options={backgroundStyle}
                        title="Background Effect"
                        property="styleBackground"
                        selected={theme.styleBackground}
                        update={this.updateBackgroundStyle}
                        theme={theme}
                    />
                </div>
                <div>
                    <h4>Background Images</h4>
                    <BackgroundImages theme={theme} update={this.props.update}/>
                </div>
                <Gap20/>
            </ThemeSection>
        );
    }
}

export default ThemeEditorContainer(withStyles(colorStyles)(ThemeColors));

